var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w3-border-theme source-code-box"},[_c('pre',{directives:[{name:"highlightjs",rawName:"v-highlightjs",value:(_vm.source),expression:"source"}]},[_c('code',{staticClass:"openscad"})])])}
var staticRenderFns = []

export { render, staticRenderFns }